import React from "react";

import LeadershipAccountability from "../component/LeadershipAccountability.jsx";
import NavbarComponent from "../component/NavbarComponent.jsx";

const LAForm = () => (
  <div>
    <LeadershipAccountability />
  </div>
);

export default LAForm;
